import React, { useState } from 'react'

import { useGetBotStatusQuery, useSetBotStatusMutation } from '@/store/chat-api'
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'

export const BotStatusToggle: React.FC = () => {
  const { data, refetch } = useGetBotStatusQuery()
  const [setBotStatus] = useSetBotStatusMutation()
  const [confirmOpen, setConfirmOpen] = useState(false)

  const isDisabled = data?.disabled ?? false

  const handleToggle = async (): Promise<void> => {
    if (!isDisabled) {
      setConfirmOpen(true)
    } else {
      await setBotStatus(!isDisabled)
      refetch()
    }
  }

  const confirmDisable = async (): Promise<void> => {
    await setBotStatus(true)
    refetch()
    setConfirmOpen(false)
  }

  return (
    <>
      <div className="p-4 rounded-xl border border-border shadow bg-muted w-full">
        <div className="flex flex-col gap-2">
          <p className="text-lg font-semibold">Status chatbota</p>
          <div className="text-sm text-muted-foreground w-[360px] min-h-[40px]">
            {isDisabled
              ? 'Chatbot je trenutno neaktivan i neće odgovarati na pitanja.'
              : 'Chatbot je aktivan i odgovaraće na korisnička pitanja.'}
          </div>
          <div className="flex items-center gap-4 mt-2">
            <input
              id="bot-toggle"
              type="checkbox"
              checked={!isDisabled}
              onChange={handleToggle}
              className="peer sr-only"
            />
            <div
              className={`relative h-6 w-11 cursor-pointer rounded-full transition-colors ${
                !isDisabled ? 'bg-green-500' : 'bg-red-500'
              }`}
              onClick={handleToggle}
              title={!isDisabled ? 'Chatbot je aktivan' : 'Chatbot je neaktivan'}
            >
              <div
                className={`absolute left-0 top-0 size-6 rounded-full bg-white shadow transition-transform ${
                  !isDisabled ? 'translate-x-5' : 'translate-x-0'
                }`}
              />
            </div>
            <span className="text-sm">{isDisabled ? 'Neaktivan' : 'Aktivan'}</span>
          </div>
        </div>
      </div>

      <Dialog open={confirmOpen} onOpenChange={setConfirmOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Da li ste sigurni da želite da deaktivirate bota?</DialogTitle>
          </DialogHeader>
          <p className="text-sm text-muted-foreground">
            Ako deaktivirate bota, korisnici neće moći da dobiju odgovore dok ga ponovo ne aktivirate.
          </p>
          <DialogFooter className="mt-4">
            <Button variant="outline" onClick={() => setConfirmOpen(false)}>
              Otkaži
            </Button>
            <Button variant="destructive" onClick={confirmDisable}>
              Deaktiviraj bota
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  )
}
